import { Router } from "./app/router";

export function App() {
  return <Router />;
}
